var React = require('react');

function MapMarker (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 192c0 77.41-27 99-172.27 309.67a24 24 0 0 1-39.46 0C27 291 0 269.41 0 192 0 86 86 0 192 0s192 86 192 192z","className":"fa-secondary","key":1})]);
}

MapMarker.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MapMarker;

MapMarker.default = MapMarker;
